import { useMutation } from '@tanstack/react-query'
import { useUserData } from 'auth'
import Loading from 'components/Loading'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTRPC } from 'utils/trpc'

const prod = import.meta.env.VITE_APP_STAGE == 'prod'

const docusignBaseUrl = `https://account${prod ? '' : '-d'}.docusign.com`

export const XeroConnectionResponse = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const state = searchParams.get('state')

    useEffect(() => {
        navigate(`/${state}/xero/auth?${searchParams.toString()}`)
    }, [])

    return <Loading />
}

export const LoggedInXeroConnectionResponse = () => {
    const navigate = useNavigate()
    const trpc = useTRPC()
    const { user, refreshUser } = useUserData()
    const [searchParams] = useSearchParams()

    const code = searchParams.get('code')
    const setTokenMutation = useMutation(trpc.xero.setToken.mutationOptions())

    const setToken = async () => {
        if (!code) return
        await new Promise(r => setTimeout(r, 100))
        await setTokenMutation.mutateAsync({ code })
        await refreshUser()
        navigate(`../../settings?tab=Xero`, {
            replace: true,
            relative: 'path',
        })
    }

    useEffect(() => {
        setToken()
    }, [])

    return <Loading />
}
